"use strict";

var _taggedTemplateLiteral = require("/home/circleci/project/story/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Text = exports.Container = exports.Button = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _typography = require("@titelmedia/bricks-theme/lib/utilities/typography");

var _transitions = require("@titelmedia/bricks-theme/lib/variables/transitions");

var _layout = require("@titelmedia/bricks-theme/lib/utilities/layout");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Container = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"])), (0, _layout.setContainer)({
  size: 'sm'
}));

exports.Container = Container;

var Text = _styledComponents.default.p(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-family: 'univers-black', sans-serif;\n  margin-bottom: 30px;\n  text-align: center;\n  ", "\n"])), (0, _typography.setFontSizes)({
  mobile: '20px',
  tablet_vertical: '24px',
  tablet_horizontal: '24px'
}));

exports.Text = Text;

var Button = _styledComponents.default.a(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  border: 1px solid black;\n  height: 48px;\n  padding: 0px 20px;\n  text-transform: uppercase;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: black;\n  text-decoration: none;\n  transition: ", " all;\n  ", "\n  ", "\n\n  &:hover {\n    background: black;\n    color: white;\n  }\n"])), _transitions.TRANSITIONS.QUICK, (0, _typography.setFont)({
  bold: true
}), (0, _typography.setFontSizes)({
  mobile: '13px',
  tablet_vertical: '14px',
  tablet_horizontal: '14px'
}));

exports.Button = Button;